module.exports = __webpack_public_path__ + "static/media/cancel_small.a8068c9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/cancel_small.svg
// module id = 171
// module chunks = 0